<template>
    <div class="returnNavBarLeft">
        <van-icon name="arrow-left" @click="handleClickReturnRouter" />
        <span :class="{'normal_title': isTitleNormal}" @click="handleClickReturnRouter" v-text="title"></span>
        <i v-if="isAllFunctions" class="iconfont icon-gengduogongneng_weixuanzhong menu-icon" @click="handleClickAllFunctions"></i>
        <slot />
    </div>
</template>

<script>
export default {
    name: "ReturnNavBar",
    props: {
        title: {
            type: String,
            default: '',
        },
        isTitleNormal: {
            type: Boolean,
            default: false
        },
        isAllFunctions: {
            type: Boolean,
            default: false
        },
        // 是否自定义返回事件
        isCustomReturnEvent: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {

        }
    },
    methods:{
        handleClickReturnRouter() {
            if(this.isCustomReturnEvent) {
                this.$emit("returnEvent")
            } else {
                if (this.$router.history.length <= 1) {
                    // 没有上一页，跳转到固定页面
                    this.$router.push({ name: 'mobileAllFunctions' });
                } else {
                    // 有上一页，后退
                    this.$router.go(-1);
                }
            }
        },
        handleClickAllFunctions(){
            this.$router.push({ name: 'mobileAllFunctions' });
        },
    },
    watch: {

    }
}
</script>

<style  lang="scss" scoped>

</style>
